import { useEffect, useState } from "react"
import { TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { RsvpDetails, Settings, StepsTranslations } from "../../models/api/rsvpApiTypes"
import { useAppSelector } from "../../hook/useReduxHooks"
import { RootState } from "../../redux/store"
import { resolveTranslation } from "../../utils/translations"
import RsvpBox from "../RsvpBox"
import busStepIcon from "../../icon/bus-icon.svg"
import StepBus from "./StepBus"

interface StepBusBoxProps {
  settings: Settings
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  stepPipeline: string[]
  setStep: (name: string) => void
}

export default function StepBusBox({ settings, rsvp, stepPipeline, setRsvp, setStep }: StepBusBoxProps) {
  const [busStrings, setBusStrings] = useState<StepsTranslations | undefined>({
    lang: "",
    strings: [],
  })
  const language = useAppSelector((state: RootState) => state.languageReducer.language).toLocaleLowerCase()

  useEffect(() => {
    const newBusStrings =
      resolveTranslation(settings.steps?.find((x) => x.name === "bus")?.translations ?? [], language)
    setBusStrings(newBusStrings)
  }, [language, settings.steps])

  return (
    <div className="box">
      <RsvpBox
        iconAlt="busStepIcon"
        iconSource={busStepIcon}
        title={busStrings?.strings.find((x) => x.type === TranslationsStringsType.TITLE)?.value}
        description={busStrings?.strings.find((x) => x.type === TranslationsStringsType.DESCRIPTION)?.value}
      >
        <StepBus
          buttonColor={settings.rsvpStyle.buttonColor === null ? "#0c6efb" : settings.rsvpStyle.buttonColor}
          backButtonColor={settings.rsvpStyle.backButtonColor === null ? "#a6b7d4" : settings.rsvpStyle.backButtonColor}
          strings={busStrings?.strings}
          rsvp={rsvp}
          setRsvp={(rsvp) => setRsvp(rsvp)}
          setStep={(name) => setStep(name)}
          stepPipeline={stepPipeline}
        />
      </RsvpBox>
    </div>
  )
}
